collections.service('ClosedTradeCollection', [
    function () {

        function ClosedTradeCollection(a) {
            var entities = a || [];

            this.add = function (item) {
                entities.push(item);
            };

            this.get = function (rule) {
                return _.find(entities, rule);
            };

            this.find = function (rule) {
                return _.filter(entities, rule);
            };

            this.sort = function (rule) {
                return _.orderBy(entities, rule);
            };

            this.remove = function (rule) {
                return _.remove(entities, rule);
            };

            this.getAllTrades = function () {
                return _(entities)
                    // .filter(function (item) {
                    //     return item.actionCode < 6 || item.actionCode > 7;
                    // })
                    .value();
            };

            this.getAll = function () {
                return entities;
            };

            this.length = function () {
                return entities.length;
            };

            this.clear = function () {
                entities.forEach(function (item) {
                    if (item.clear() === 'function') {
                        item.clear();
                    }
                });
                entities = [];
            }
        }

        return ClosedTradeCollection;
    }]);
